import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControl from '@mui/material/FormControl';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import CustomSelect from "../CustomComponents/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import MomentUtils from "@date-io/moment";
import WeekPicker from "../../TimesheetItems/WeekPicker";
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import MUIDataTable from 'mui-datatables';
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions} from '../../utils';
import { Link } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import EditSummaryDialog from "../../AdminItems/EditDialogue/EditSummary";
import Tooltip from '@mui/material/Tooltip';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { makeStyles } from "@mui/styles";
const ExcelJS = require('exceljs');
const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));

export default function ReportTimeEntryBilled () {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [StartDate, setStartDate] = React.useState(moment(new Date()).startOf('month').format('YYYY-MM-DD'));
    const [EndDate, setEndDate] = React.useState(moment(new Date()).endOf('month').format('YYYY-MM-DD'));
    const [dataSet, setDataSet] = React.useState([]);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [permission, permissionSet] = React.useState([]);
    const [taskVariable, setTaskVariable] = React.useState([]);
    const [customColumns, setCustomColumns] = React.useState([]);
    const [expand, setExpand] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(true);
    const [addCols, setAddCols] = React.useState(true);
    const [LockedAlert, setAlert] = React.useState(false);
    const [AlertText, setAlertText] = React.useState('');
	const [overTime, setOverTime] = React.useState([]);
	
    const classes = pageStyles();

    const initialValues = {
        POID: ''
    };
    
    const validFormSchema = Yup.object({
        POID: Yup
            .string('Select a PO')
            .required('PO selection Required'),
            
    })

    React.useEffect(() => {
    //	logger("In UseEffect")
    	checkAuthentication();
        if (refresh) {
            
            fetch(`/api/User/Permission`)
                .then(res => res.json())
                .then(json => permissionSet(json))

            fetch(`/api/taskVariable/dropdown`)
                .then(res => res.json())
                .then(json => setTaskVariable(json))
            setRefresh(false);
        }
        if (dataSet.length && addCols) {
            addColumn(taskVariable)
        }
    })
    
	const convertDates = (json) => {
		json.forEach(eachObj => {
			if (eachObj.Rate) {
				const byteArray = new Uint8Array(eachObj.Rate.data);
				const textDecoder = new TextDecoder();
				const res = textDecoder.decode(byteArray);
				const r = parseFloat(res).toFixed(2);
				eachObj.Rate = r;
			}
		});
		if (json.length===0){
			setOpenLogs(false);
			setAlertText("No Invoices billed for the time selected");
			setAlert(true);
		}
		setIsLoading(false);
		setDataSet(json);
	};
    
   const getDataSet = async () => {
		try {
			const apiUrl = `/api/Reports/time_entry/${moment(StartDate).format('YYYY-MM-DD')}/${moment(EndDate).format('YYYY-MM-DD')}/0/1`;
			logger(apiUrl);

			const response = await fetch(apiUrl, { method: 'GET' });
			const json = await response.json();
			
			if (json.length > 0) {
				await GetOverTime(json[0].SOWID); // Await here is correct
			}

			logger('output', json);
			convertDates(json);

			

			//setRefresh(true);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};
	
	
	const GetOverTime = async (sow) => {
		try {
			const response = await fetch(`/api/SOW/OverTime/${sow}`, { method: 'GET' });
			const json = await response.json();

			setOverTime(json); // Ensure `overTime` is defined in the appropriate scope
		} catch (error) {
			console.error('Error fetching overtime data:', error);
		}
	};


    const handleGenerate = () => {
		setOpenLogs(true);
        getDataSet()
        setIsLoading(true);
    };
    
    const handleAlertClose = () => {
        setAlert(false);
    };
    
    const calculateRate = (rate, flagType) => {
		if (overTime.length) {
			if (flagType === 'OT') {
				return (rate * overTime[0].OverTimeWeek).toFixed(2);
			} else if (flagType === 'WND') {
				return (rate * overTime[0].OverTimeWeekEnd).toFixed(2);
			} else if (flagType === 'HOL') {
				return (rate * overTime[0].OverTimeHoliday).toFixed(2);
			} else {
				return rate;
			}
		}
	};

    const addColumn = (list) => {
        logger("addColumn", list);
        const editableColumns = [
            {
                name: "PO",
                label: "PO",
                options: {
                    sort: true,
                    filter: true,
                    filterOptions: {
                        renderValue: val => {
                            if (val === "" || val === null || val === undefined) {
                                return "Not Set";
                            }
                            return val;
                        }
                    },
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        logger(`dataSet[dataIndex]`, dataSet[dataIndex])
                        if (dataSet[dataIndex].IsBillable == 0) {
                            return (
                                <>non-Billable</>
                            );
                        }
                        else {
                            if (dataSet[dataIndex].PO !== null)
                                return (
                                    <>{dataSet[dataIndex].PO}</>
                                );
                            else
                                return (
                                    <div>
                                        <Tooltip title='Failing' className={classes.root}>
                                            <ReportGmailerrorredIcon color='error' />
                                        </Tooltip>
                                        <EditSummaryDialog
                                            callRefresh={callRefresh}
                                            handleEditCallback={handleEditCallback}
                                            permission={permission}
                                            data={{ "Name": dataSet[dataIndex].Name, "UserID": dataSet[dataIndex].UserID, "WeekOf": moment.utc(dataSet[dataIndex].DayOf).day("Monday").format('YYYY-MM-DD') }} />
                                    </div>
                                );
                        }
                    }
                }
            },
            {
                name: "PO Number",
                label: "PO Number",
                options: {
                    sort: true,
                    filter: true,
                    filterOptions: {
                        renderValue: val => {
                            if (val === "" || val === null || val === undefined) {
                                return "Not Set";
                            }
                            return val;
                        }
                    },
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        logger(`dataSet[dataIndex]`, dataSet[dataIndex])
                        if (dataSet[dataIndex].IsBillable == 0) {
                            return (
                                <>non-Billable</>
                            );
                        }
                        else {
                            if (dataSet[dataIndex].PO !== null)
                                return (
                                    <>{dataSet[dataIndex].PoNumber}</>
                                );
                            else
                                return (
                                    <div>
                                        <Tooltip title='Failing' className={classes.root}>
                                            <ReportGmailerrorredIcon color='error' />
                                        </Tooltip>
                                        <EditSummaryDialog
                                            callRefresh={callRefresh}
                                            handleEditCallback={handleEditCallback}
                                            permission={permission}
                                            data={{ "Name": dataSet[dataIndex].Name, "UserID": dataSet[dataIndex].UserID, "WeekOf": moment.utc(dataSet[dataIndex].DayOf).day("Monday").format('YYYY-MM-DD') }} />
                                    </div>
                                );
                        }
                    }
                }
            },
            {
                name: "InvoiceNumber",
                label: "InvoiceNumber",
                options: {
                    filter: false,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
                name: "DayOf",
                label: "Date",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        return (
                            moment.utc(dataSet[dataIndex].DayOf).format("MM/DD/YYYY")
                        );
                    }
                }
            },
            {
                name: "WeekOf",
                label: "WeekOf",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        return (
                            moment.utc(dataSet[dataIndex].WeekOf).format("MM/DD/YYYY")
                        );
                    }
                }
            },
            {
                name: "Name",
                label: "Name",
                options: {
                    filter: false,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
                name: "Lab_Name",
                label: "Program",
                options: {
                    filter: true,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
                name: "Project",
                label: "Project",
                options: {
                    filter: true,
                    sort: true,
                    //    position: "sticky",
                }
            },

            {
                name: "Task",
                label: "Task",
                options: {
                    filter: true,
                    sort: true,
                    //    position: "sticky",
                }
            },
            
            {
                name: "Hours",
                label: "Hours",
                options: {
                    filter: false,
                    sort: true,
                    //    position: "sticky",
                }
            },
            {
            name: "Position_FullName",
            label: "FullPosition",
            options: {
                filter: false,
                sort: true,
                display: true,
                //    position: "sticky",
            }
            },
            		{
				name: "FlagType",
				label: "FlagType",
				options: {
					sort: true,
					filter: true,
					customBodyRenderLite: (dataIndex, rowIndex) => {
						if (dataSet[dataIndex].ProjectGroupName == "BCI") {
							return (
								<>non-Billable</>
							);
						}
						else {
							if (dataSet[dataIndex].FlagType) {

								return (
									<Tooltip title={dataSet[dataIndex].overTimeWarning ? "overTimeWarning" : ""}>
										<div style={dataSet[dataIndex].overTimeWarning ? { color: "red" } : {}}>

											{dataSet[dataIndex].FlagType}
										</div>
									</Tooltip>
								);
							}

						}
					}
				}
			},
            {
                name: "Rate",
                label: "RawRate",
                options: {
                    sort: true,
                    filter: true,
                    filterOptions: {
                        renderValue: val => {
                            if (val === "" || val === null || val === undefined) {
                                return "Not Set";
                            }
                            return val;
                        }
                    },
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        logger(`value`, dataSet[dataIndex])
                        if (dataSet[dataIndex].IsBillable == 0) {
                            return (
                                <>-----</>
                            );
                        }
                        else {
                            if (dataSet[dataIndex].Rate) {
                                return (
                                   <>{overTime.length ? calculateRate(dataSet[dataIndex].Rate, dataSet[dataIndex].FlagType) : dataSet[dataIndex].Rate}</>
                                );
                            }
                            else {
                                return (
                                    <Tooltip title='Failing' className={classes.root}>
                                        <ReportGmailerrorredIcon color='error' />
                                    </Tooltip>
                                );
                            }
                        }
                    }

                } 
            },
       ];
        if (expand==="detailed") {
			list.forEach((e) => {
				editableColumns.push({
					name: `${e.Name}`,
					label: `${e.Name}`,
					options: {
						filter: true,
						sort: true,
					}
				})
			})
		}else if(expand==="summary"){
			editableColumns.push(
				{
	            name: "TaskVariables",
	            label: "TaskVariables",
                    options: {
                        filter: false,
                        sort: false,
	                customBodyRender: (value, tableMeta, updateValue) => {
						var rowIndex = tableMeta.rowIndex;
						
						return list.map((item, idx) => {
							var columnName = item.Name;
							var data = dataSet[rowIndex];
							var value = data[columnName]?data[columnName]:'';
							return (data[columnName] &&
                                <React.Fragment key={idx}>
                                    {columnName + ': ' + value}
                                    <br />
                                </React.Fragment>
                            );
						});
	                }
	            }
	        })
		}
        setAddCols(false);
        setCustomColumns(editableColumns);
    };

    const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true)
        setExpand("");
    };
    
    const handleStartDate = (Data) => {
        setStartDate(Data.target.value);
        logger(Data.target.value);
    }

    const handleEndDate = (Data) => {
        setEndDate(Data.target.value);
        logger(Data.target.value);
    }

    const handleClose = () => {
     //   setPOChoices(0);
        setOpen(false);
    };

    const handleOpenForLogs = () => {
        setOpenLogs(true)
    };

    const handleCloseForLogs = () => {
        setDataSet([])
        setCustomColumns([])
        setOpenLogs(false);
		setAddCols(true);
    }; 

    const callRefresh = () => {
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {
        fetch("/api/Summary", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "ApprovalAll": childData.approvalAll,
                "Week": childData.Week
            })
        })

        logger(childData)
        //   window.location.reload();
        setRefresh(true)
    };
    
    const handleRadioButton = (event) => {
		setExpand(event.target.value);
	}

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: initialRowsPerPage,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
		    toolbar: {
		      search: "Search",
		      downloadCsv: "Download Excel", 
		      print: "Print",
		      viewColumns: "View Columns",
		      filterTable: "Filter Table",
		    	},
	  	},
        selectableRows: 'none',
		onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);				
				if (expand === "summary") {
					for (let i = 0; i < dataSet.length; i++) {
						let taskVarsString = "";
						let eachRow = dataSet[i];
						logger(eachRow);
						for (let k = 0; k < taskVariable.length; k++) {
							let eachTaskVar = taskVariable[k].Name;
							for (let j in eachRow) {
								if (eachTaskVar === j && eachRow[j] !== null && eachRow[j] !== undefined && eachRow[j] !== "") {
									taskVarsString = taskVarsString + eachTaskVar + ": " + eachRow[eachTaskVar] + "\n";
								}
							}
						}
						data[i].data[data[i].data.length - 1] = taskVarsString;
					}
				}
				for (var i = 0; i < dataSet.length; i++) {
					var eachRow = data[i].data;
					logger("eachrow", eachRow)
					eachRow[1] = dataSet[i].PoNumber; 					
					eachRow[12] = calculateRate(eachRow[12], eachRow[11]);
					eachRow[3] =  moment.utc(eachRow[3]).format("MM/DD/YYYY")
					eachRow[4] =  moment.utc(eachRow[4]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({ data: data, headers: headers, columnIndexToRemove:0} );
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			var add_date = true;
			var columnIndexToRemove = 0;
			var numberOfColumnsToRemove = null;
			var filename = 'BilledTimeEntry.xlsx';
			
			if (columnIndexToRemove !== null) {
				if (numberOfColumnsToRemove !== null) {
					headers.splice(columnIndexToRemove, numberOfColumnsToRemove);
				} else {
					headers.splice(columnIndexToRemove, 1);
				}
			}
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Sheet 1');
		
			const headerRow = worksheet.addRow(headers);
			headerRow.font = { bold: true };
		
			rows.forEach((row, rowIndex) => {
			    const newRow = worksheet.addRow(Object.values(row));
			    logger("newRow", newRow);
			
			    worksheet.columns.forEach((col, colIndex) => {
			        const headerLength = col.header ? col.header.length : 0; // Handle header if undefined
			        var maxColumnWidth = col.values.reduce((maxWidth, value) => {
			            if (value && value.length > maxWidth) {
			                return value.length;
			            }
			            return maxWidth;
			        }, 0);
			
			        if (maxColumnWidth > 40) {
			            maxColumnWidth = 40;
			        }
					col.width = Math.max(headerLength, maxColumnWidth) + 2;
					col.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
					if (dataSet[rowIndex]) {
						if (colIndex === 7 && (dataSet[rowIndex].VerifyStatus === 0 || dataSet[rowIndex].VerifyStatus === -1) ){ //
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
						if ((colIndex === 8) && dataSet[rowIndex].overTimeWarning) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
					}
				});
			});
		
			const currentDate = moment.utc().format("yyyy-MM-DD");
			// Generate the Excel file
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
					: (filename || 'datatable.xlsx');
				a.click();
			});
			
			
			return false;
		}

    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div>
        <MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                    Report Billed Time Entry
            </Button>
             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            //onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                           edge="start"
                                           color="inherit"
                                           onClick={handleClose}
                                           aria-label="close"
                                        >
                                          <CloseIcon />
                                        </IconButton>
											<Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
												Report Billed Time Entry
											</Typography>
											<FormControl>
												<RadioGroup
													aria-labelledby="radio-buttons-group-label"
													name="radio-buttons-group"
													value={expand}
													onChange={handleRadioButton}
													row
												>
													<Tooltip title="Shows Time Entry Task Variables">
														<FormControlLabel value="summary" control={<Radio sx={{
															'& .MuiSvgIcon-root': {
																color: "white"
															},
														}} />} label="Summary" />
													</Tooltip>
													<Tooltip title="Shows Time Entry detailed Task Variables">
														<FormControlLabel value="detailed" control={<Radio sx={{
															'& .MuiSvgIcon-root': {
																color: "white"
															},
														}} />} label="Detailed" />
													</Tooltip>
												</RadioGroup>
											</FormControl>
											<Button color="inherit" onClick={handleGenerate}>
												Generate
											</Button>
										</Toolbar>
									</AppBar>
                                    <DialogTitle>Report Billed Time Entry:</DialogTitle>            
                                 <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='start'
                                                id="outlined-StartDate"
                                                type="date"
                                                onChange={handleStartDate}
                                                value={StartDate}
                                                label="Start Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='start'
                                                id="outlined-StartDate"
                                                type="date"
                                                onChange={handleEndDate}
                                                value={EndDate}
                                                label="End Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                </div>
                            </Form>
                        )}
                        </Formik>
                        <Dialog open={openLogs} onClose={handleCloseForLogs} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                            <DialogContent >
                                <Box>

                                    <MUIDataTable
                                        title={

                                            <Typography variant="h6" style={{ color: "white" }}>
                                                <IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
                                                Report Billed Time Entry
                                                <Button component={Link} color="inherit" to="/Summary">Go to Summary</Button>
                                            </Typography>
                                        }
                                        data={isLoading ? [] :dataSet}
                                        columns={customColumns}
                                        options={isLoading?muiLoaderOptions(options, isLoading):options}
                                    />
                                </Box>
                            </DialogContent>
                        </Dialog>
                        <Dialog
			                open={LockedAlert}
			                onClose={handleAlertClose}
			                aria-labelledby="L&P Lock"
			                aria-describedby="Time Period locked for this work"
			            >
			                <DialogTitle id="Time Entry">
			                    {"Alert"}
			                </DialogTitle>
			                <DialogContent>
			                    <DialogContentText id="alert-dialog-description">
			                        {AlertText}
			                    </DialogContentText>
			                </DialogContent>
			                <DialogActions>
			                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
			                </DialogActions>
			            </Dialog>
                </DialogContent>                
            </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
 